import React, { useState } from "react";
import { useGlobalContext } from "../../context/GlobalContext";
import { Oval } from "react-loader-spinner";
import VentanaPerfil from "./components/VentanaPerfil";

export default function UniversalIconPerfil() {
  const { perfil, errorPerfil, loadingPerfil } = useGlobalContext();
  // Estado para controlar la visibilidad del modal
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  if (loadingPerfil) {
    return (
      <Oval
        visible={true}
        height="50"
        width="50"
        color="#fff"
        secondaryColor="#f5f5f5"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    );
  }

  if (errorPerfil) {
    return <p>Error: {errorPerfil}</p>;
  }

  return (
    <>
      {/* Al hacer click se cambia el estado a true para mostrar el modal */}
      <div
        data-figma-id="810:15698"
        className="perfil-icono"
        onClick={() => {
          if (openModal) {
            // Si el modal ya está abierto, lo cerramos
            setShowModal(false);
            setTimeout(() => {
              setOpenModal(false);
            }, 250);
          } else {
            // Si el modal está cerrado, lo abrimos
            setOpenModal(true);
            setTimeout(() => {
              setShowModal(true);
            }, 10);
          }
        }}
      >
        <p data-figma-id="810:15699" className="perfil-icono-texto">
          {perfil.datos.informacion_del_usuario.iniciales}
        </p>
      </div>
      {/* Renderizado condicional del modal */}
      {openModal && (
        <VentanaPerfil
          datosPerfil={perfil.datos.informacion_del_usuario}
          onClose={() => {
            setShowModal(false);
            setTimeout(() => {
              setOpenModal(false);
            }, 250);
          }}
          isOpen={showModal}
        />
      )}
    </>
  );
}
